import React from 'react';

const BookmarkRemoveIcon = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="3" y="3" width="2" height="2" fill="currentColor" />
    <rect x="5" y="5" width="2" height="2" fill="currentColor" />
    <rect x="7" y="7" width="2" height="2" fill="currentColor" />
    <rect x="11" y="11" width="2" height="2" fill="currentColor" />
    <rect x="9" y="9" width="2" height="2" fill="currentColor" />
    <rect x="13" y="13" width="2" height="2" fill="currentColor" />
    <rect x="15" y="15" width="2" height="2" fill="currentColor" />
    <rect x="17" y="17" width="2" height="2" fill="currentColor" />
    <rect x="19" y="19" width="2" height="2" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 21 3)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 19 5)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 17 7)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 15 9)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 9 15)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 11 13)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 7 17)" fill="currentColor" />
    <rect width="2" height="2" transform="matrix(-1 0 0 1 5 19)" fill="currentColor" />
    <path d="M3 3H5V5H3V3Z" fill="currentColor" />
    <path d="M7 7H5V5H7V7Z" fill="currentColor" />
    <path d="M9 9H7V7H9V9Z" fill="currentColor" />
    <path d="M11 11H9V9H11V11Z" fill="currentColor" />
    <path
      d="M13 11H11V13H9V15H7V17H5V19H3V21H5V19H7V17H9V15H11V13H13V15H15V17H17V19H19V21H21V19H19V17H17V15H15V13H13V11Z"
      fill="currentColor"
    />
    <path d="M15 9V11H13V9H15Z" fill="currentColor" />
    <path d="M17 7V9H15V7H17Z" fill="currentColor" />
    <path d="M19 5V7H17V5H19Z" fill="currentColor" />
    <path d="M19 5V3H21V5H19Z" fill="currentColor" />
  </svg>
);

export default BookmarkRemoveIcon;
